import MainServices from '@/components/servicePage/MainServices'
import ServiceBanner from '@/components/servicePage/ServiceBanner'
import React from 'react'

export default function ServicePage() {
  return (
    <>
        <ServiceBanner/>
        <MainServices/>
    </>
  )
}